export function ExhibitHeader({
  readoutVisible,
  onToggleReadout,
  demoNumber = "001",
  title = "Phases of the Moon",
  chain = "Sunlight → orbital position → illuminated half → phase seen from Earth",
}: {
  readonly readoutVisible: boolean;
  readonly onToggleReadout: () => void;
  readonly demoNumber?: string;
  readonly title?: string;
  readonly chain?: string;
}) {
  return (
    <header className="exhibit-heading">
      <p className="eyebrow">
        <a className="back-link" href="#/">
          ← All demos
        </a>
        Pupil · Astrophysics · Demo #{demoNumber}
      </p>
      <h1>{title}</h1>
      <p>{chain}</p>
      <button
        aria-expanded={readoutVisible}
        className="readout-toggle"
        type="button"
        onClick={onToggleReadout}
      >
        Notes
        <span aria-hidden="true">{readoutVisible ? "▾" : "▸"}</span>
      </button>
    </header>
  );
}
